import { IntroHeader } from "../components/common/Header";
import fashionVideo from "../assets/videos/home_fashion_background_low.mp4";

import {About as AboutUs} from "../components/About";
import Services from "../components/Services";
import { Portfolio } from "../components/Portfolio";
/* import Testimonials from "../components/Testimonials"; */
/* import Contact from "../components/Contact"; */
import AIChat from "../components/AIChat";
import Partners from "../components/Partners";



const LandingFashion = () => {
    return (
        <>
              <IntroHeader 
        backgroundType="video"
        backgroundSrc={fashionVideo}
        maskClass="opacity-8 bg-primary"
      />

            <div id="content" role="main" className="bg-light">
                <AboutUs />
                <Services />
                <Portfolio />
                <AIChat />
                <Partners></Partners>
            </div>
        </>
        )
    
  };
  
  export default LandingFashion ;